export type SeriesItem = {
  id: string;
  title: string;
  description: string;
  images: string[];
};

export const imagePath = (seriesId: string, imageName: string) => `/${seriesId}/${imageName}`;

export const series: SeriesItem[] = [
  {
    id: 'zee',
    title: 'Zee',
    description: `Daar waar zee en lucht elkaar raken en een worden. Ik werk met bijenwas en pigmenten op houten panelen. Dit noemt men 'encaustiek', ook wel bekend als hete was schilderen, door bijenwas te verwarmen en gekleurde pigmenten hieraan toe te voegen.`,
    images: [
      '29A06198-95AB-4147-8B48-E7F0F8655AC0.JPG',
      '30686241-2391-416E-BD17-DEB6F714AF39.jpeg',
      '309BB026-F24B-4041-AB43-57FCAB87BD29.JPG',
      '3C0ABA7F-A3C7-4A7F-A1B4-85E1E62ECA54.JPG',
      '49E5BEE3-ACAE-45A7-BA69-86A69FD13096.JPG',
      '86705A2F-2665-4E7F-9855-EE02D280FED1.JPG',
      '880E2C4D-3549-4893-B9B8-3A23AAEB6C25.JPG',
      '892CE8C6-9852-4F58-AF8B-0F8B614CE676.JPG',
      'A74D6AB3-5A15-4099-85DA-78C5A09F81DD.jpeg',
      'BB1411B0-61BE-4925-AFD8-C4AA03A6577F.JPG',
      'C7B3D638-C374-4ED5-A45F-F24D7B1ED300.JPG',
      'CA50875F-0FD2-429F-834E-FB446C099D3B.JPG',
      'EDC47459-F294-49A1-98DA-0507B21E53F1.JPG',
      'F2B2A263-8B7C-4C73-8B47-7F20B488F26A.JPG',
      'F54F54F2-B05F-4AF9-A9FF-D3977ADB6899.JPG',
      'F9EB64CB-32E8-4A16-AF15-D769F4F903C8.JPG',
      'was-1.JPG',
      'was-2.JPG',
      'was-3.JPG',
      'was-4.JPG',
      'was-5.JPG',
      'was-6.JPG',
      'was-7.JPG',
      'was-8.JPG',
      'was-9.JPG',
    ],
  },
  {
    id: 'papier',
    title: 'Collage papier',
    description: `In mijn collages maak ik gebruik van gescheurde papiertjes op een ondergrond van papier. De uitdaging is om vorm, kleur en compositie naar mijn hand te zetten en de gelaagdheid van het werk te laten zien. Ik kies voor speelse taferelen.`,
    images: [
      '0D920760-1FDF-4C07-8746-3D3FAF76005C.JPG',
      '0F430F43-F84A-4193-9559-66FC85577CAF.JPG',
      '26946391-0191-4F96-BC2F-A68C4F7A975D.JPG',
      '3267CC10-B7EC-4037-8D17-7EA5A65BAEBC.JPG',
      '4A034632-3AB5-4F93-9A7C-4EAB564A930F.JPG',
      '5731AFD3-C5D2-4446-B73F-6201F4B25154.JPG',
      '65FDE9D8-99C7-442D-8BBA-45189CC1974A.JPG',
      '71DF23BB-C57D-4792-9BF0-3BEA84578F0E.jpeg',
      '7581CB06-645A-4962-BED3-C4C23971A667.jpeg',
      '7667AEB9-8ACA-4C51-B760-2CFB01109AA1.JPG',
      '9659683E-6099-4D1A-8A76-05D162B263EE.JPG',
      'A18AF447-6A20-4377-82B7-2BEA9DED338B.JPG',
      'F619F2B8-0AF7-4349-964B-8AF613D785E9.JPG',
      'IMG_7753.JPG',
      'IMG_7754.JPG',
      'IMG_8617.jpeg',
      'IMG_8646.jpeg',
      'IMG_8818.jpeg',
      'IMG_8822.jpeg',
      'IMG_8837.jpeg',
      'IMG_8913.jpeg',
    ],
  },
  {
    id: 'encaustiek',
    title: 'Collage encaustiek',
    description: `In mijn collages encaustiek maak ik gebruik van bijenwas op houten paneeltjes, met pigmenten, papiertjes, krassen, laag over laag, zoekend naar een abstract geheel.`,
    images: [
      '06A4FCD0-CC5F-4CA6-9ED3-852196C99BF6.JPG',
      '06D5FEB8-3029-4D55-9BFC-3E470F448490.jpeg',
      '2C6BD71D-B76A-4749-B09E-9D11C85B1A34.jpeg',
      '48B43569-A5DD-4185-A9F9-D4795C174083.JPG',
      '5D563EA9-4EED-46B2-81E7-D66EE9AE9AA2.jpeg',
      '93E8C01F-B57A-4E17-8D19-7DE05705E79C.JPG',
      '9C706FD9-53A9-4060-9A9B-D91E37E05A23.JPG',
      'DFC90884-A499-4580-AE54-282CCB60DCF4.jpeg',
      'F2F9779C-D357-475A-9734-095829522D02.JPG',
    ],
  },
  {
    id: 'figuratief',
    title: 'Figuratief',
    description: `In het figuratieve schilderen, vaak naar life model in korte standen, gebruik ik een vlotte lijn of penseelstreek, die een abstract beeld opleveren.`,
    images: [
      '29123CB1-0A6B-4119-AFB0-F401C9FAE532.JPG',
      '464CD19D-A3A8-4B61-9EA1-1443E49D2199.JPG',
      '8A6201B5-80ED-47F7-A982-A007F5D93125.JPG',
      'C5644F43-3BC0-40B1-BC4B-20253B0FE797.JPG',
      'D2597F6F-B9FB-4878-A2B8-244A27B84FAB.JPG',
      'D3869CB3-C853-4C55-A7FC-77DF18D0744A.JPG',
      'D8897728-162F-4C8F-9AF5-C118043F6282.JPG',
      'E73719D9-9A6D-4803-8008-0B726A004F60.JPG',
    ],
  },
  {
    id: 'portretten',
    title: 'Portretten',
    description: `Ik druk me graag uit in kleur. In deze portretten gebruik ik net als bij de andere figuratieve schilderingen graag een vlotte lijn of penseelstreek.`,
    images: [
      '2FEC31B1-C4B7-4EB8-8258-AF6875F7B90B.JPG',
      '50796F43-378D-4B01-A799-FFD95F2D4AA4.JPG',
      '996E071F-9BEF-41C8-B9AF-4AD63C3D5731.JPG',
      'A62CD091-F357-4C8F-B9D5-417BE4655FE9.JPG',
      'A6B60651-A347-4DCE-802C-FAAD20E107B1.JPG',
      'E5EA36AB-B6A8-4E67-9CA6-00291A5FCA74.JPG',
      'F7BA3EA9-1D2D-4AD8-AC83-747AFEC17E8E.JPG',
      'FC845B40-08EE-43D3-A634-4109A0D63375.JPG',
    ],
  },
];
